import React from "react";
import warningIcon from "@/images/icons/warning-icon.svg";

interface ErrorMessageProps {
  unassignMessage?: string | null;
  scheduleErrorMessage?: string | null;
}

const ErrorMessage: React.FC<ErrorMessageProps> = ({ unassignMessage, scheduleErrorMessage }) => (
  <div className="unassign-message-container d-flex flex-column justify-content-center mb-2">
    {unassignMessage && (
      <div className="unassign-message d-flex align-items-center gap-2" style={{ color: '#CA0A5D', fontSize: '1rem' }}>
        <img src={warningIcon} role="presentation" style={{ width: '1rem', height: '1rem' }} />
        {unassignMessage}
      </div>
    )}
    {scheduleErrorMessage && (
      <div className="schedule-error-message d-flex align-items-center gap-2" style={{ color: '#CA0A5D', fontSize: '1rem' }}>
        <img src={warningIcon} role="presentation" style={{ width: '1rem', height: '1rem' }} />
        {scheduleErrorMessage}
      </div>
    )}
  </div>
);

export default ErrorMessage;